import { GET_BY_ID, SESSION_MODULE } from '@inpart-io/devtools-vue';
import { type DataType, type IInfoGroup, type IInfoGroupField, type IInfoGroupFieldConfiguration } from '@inpart-io/padme-iap';
import { FieldSeparatorType } from '@inpart-io/padme-iap';

// import { FieldSeparatorType } from '@inpart-io/padme-iap';
import { store } from '@/store';
import { INFO_GROUP_CONFIGURATION_MODULE } from '@/store/infogroup-configuration-module';
import { INFO_GROUP_FIELD_CONFIGURATION_MODULE } from '@/store/infogroup-field-configuration-module';
import { INFO_GROUP_MODULE } from '@/store/infogroup-module';
import { GET_INFO_GROUPS_BY_CLASS_NAME } from '@/store/infogroup-module/getters';
import { USE_ADVANCED } from '@/store/session-module/getters';

export function getInfogroupFieldPosition(infogroupField: IInfoGroupField): number {
    if (!infogroupField.active || !store.getters[`${SESSION_MODULE}/${USE_ADVANCED}`]) {
        return infogroupField.position;
    }
    const infogroupFieldConfiguration: IInfoGroupFieldConfiguration = store.getters[`${INFO_GROUP_FIELD_CONFIGURATION_MODULE}/${GET_BY_ID}`](
        infogroupField?.configuration
    );
    return infogroupFieldConfiguration ? infogroupFieldConfiguration.position : infogroupField.position;
}

export function getInfogroupFieldLabel(infogroupField: IInfoGroupField): string {
    if (!infogroupField.active) {
        return infogroupField.defaultLabel;
    }
    const infogroupFieldConfiguration: IInfoGroupFieldConfiguration = store.getters[`${INFO_GROUP_FIELD_CONFIGURATION_MODULE}/${GET_BY_ID}`](
        infogroupField?.configuration
    );
    return infogroupFieldConfiguration ? infogroupFieldConfiguration.label : infogroupField.defaultLabel;
}

export function getInfogroupFieldDescription(infogroupField: IInfoGroupField): string {
    if (!infogroupField.active) {
        return infogroupField.defaultDescription;
    }
    const infogroupFieldConfiguration: IInfoGroupFieldConfiguration = store.getters[`${INFO_GROUP_FIELD_CONFIGURATION_MODULE}/${GET_BY_ID}`](
        infogroupField?.configuration
    );
    return infogroupFieldConfiguration ? infogroupFieldConfiguration.description : infogroupField.defaultDescription;
}

export function hasInfogroupFieldLineBreak(infogroupField: IInfoGroupField): boolean {
    // return true;
    if (!infogroupField.active) {
        return infogroupField.defaultFormat?.fieldSeparatorType ? infogroupField.defaultFormat?.fieldSeparatorType !== FieldSeparatorType.NONE : false;
    }
    const infogroupFieldConfiguration: IInfoGroupFieldConfiguration = store.getters[`${INFO_GROUP_FIELD_CONFIGURATION_MODULE}/${GET_BY_ID}`](
        infogroupField?.configuration
    );
    if (infogroupFieldConfiguration) {
        return infogroupFieldConfiguration.format?.fieldSeparatorType
            ? infogroupFieldConfiguration.format?.fieldSeparatorType !== FieldSeparatorType.NONE
            : false;
    } else {
        return infogroupField.defaultFormat?.fieldSeparatorType ? infogroupField.defaultFormat?.fieldSeparatorType !== FieldSeparatorType.NONE : false;
    }
}

export function hasInfogroupFieldSeparator(infogroupField: IInfoGroupField): boolean {
    // return true;
    if (!infogroupField.active) {
        return infogroupField.defaultFormat?.fieldSeparatorType === FieldSeparatorType.CONTINUOUS;
    }
    const infogroupFieldConfiguration: IInfoGroupFieldConfiguration = store.getters[`${INFO_GROUP_FIELD_CONFIGURATION_MODULE}/${GET_BY_ID}`](
        infogroupField?.configuration
    );
    return infogroupFieldConfiguration
        ? infogroupFieldConfiguration.format?.fieldSeparatorType === FieldSeparatorType.CONTINUOUS
        : infogroupField.defaultFormat?.fieldSeparatorType === FieldSeparatorType.CONTINUOUS;
}

export function getInfogroupFieldSubtitle(infogroupField: IInfoGroupField): string {
    // return 'toto';
    if (!hasInfogroupFieldLineBreak(infogroupField)) {
        return null;
    }
    if (!infogroupField.active) {
        return infogroupField.defaultFormat?.subtitle;
    }
    const infogroupFieldConfiguration: IInfoGroupFieldConfiguration = store.getters[`${INFO_GROUP_FIELD_CONFIGURATION_MODULE}/${GET_BY_ID}`](
        infogroupField?.configuration
    );
    return infogroupFieldConfiguration ? infogroupFieldConfiguration.format?.subtitle : infogroupField.defaultFormat?.subtitle;
}

export function isInfogroupFieldMultiple(infogroupField: IInfoGroupField): boolean {
    if (!infogroupField.active) {
        return false;
    }
    const infogroupFieldConfiguration: IInfoGroupFieldConfiguration = store.getters[`${INFO_GROUP_FIELD_CONFIGURATION_MODULE}/${GET_BY_ID}`](
        infogroupField?.configuration
    );
    return infogroupFieldConfiguration ? infogroupFieldConfiguration.multiple : true;
}

export function isInfogroupFieldEnabled(infogroupField: IInfoGroupField): boolean {
    if (store.getters[`${SESSION_MODULE}/${USE_ADVANCED}`]) {
        const infogroupFieldConfiguration: IInfoGroupFieldConfiguration = store.getters[`${INFO_GROUP_FIELD_CONFIGURATION_MODULE}/${GET_BY_ID}`](
            infogroupField?.configuration
        );
        return infogroupFieldConfiguration ? infogroupFieldConfiguration.enabled : infogroupField.enabled;
    } else {
        return infogroupField.enabled;
    }
}

export function getInfogroupCriteria(infogroup: IInfoGroup): Record<string, string[]> {
    if (store.getters[`${SESSION_MODULE}/${USE_ADVANCED}`]) {
        const infogroupConfiguration = store.getters[`${INFO_GROUP_CONFIGURATION_MODULE}/${GET_BY_ID}`](infogroup?.configuration);
        return infogroupConfiguration?.withCriteria ? infogroupConfiguration.withCriteria : infogroup.withCriteria;
    } else {
        return infogroup.withCriteria;
    }
}

export function isInfogroupEnabled(infogroup: IInfoGroup): boolean {
    return (
        (infogroup.fields?.filter((infogroupField) => {
            return isInfogroupFieldEnabled(infogroupField);
        }).length ?? 0) > 0
    );
}

export function getInfogroupByClassName(className: DataType): IInfoGroup[] {
    return store.getters[`${INFO_GROUP_MODULE}/${GET_INFO_GROUPS_BY_CLASS_NAME}`](className);
}

export function getActiveInfogroupByClassName(className: DataType): IInfoGroup[] {
    return getInfogroupByClassName(className).filter((infoGroup: IInfoGroup) => {
        return isInfogroupEnabled(infoGroup);
    });
}
